import { BaseModel } from './base.model'

const DEFAULT_USER_SHIFT_SETTINGS_PARAMS = {
  utcOffset: 3,
  workDays: [
    { day: 0, shiftBegin: "8:00", shiftEnd: "17:00", breakBegin: "12:00", breakEnd: "13:00", active: true},
    { day: 1, shiftBegin: "8:00", shiftEnd: "17:00", breakBegin: "12:00", breakEnd: "13:00", active: true},
    { day: 2, shiftBegin: "8:00", shiftEnd: "17:00", breakBegin: "12:00", breakEnd: "13:00", active: true},
    { day: 3, shiftBegin: "8:00", shiftEnd: "17:00", breakBegin: "12:00", breakEnd: "13:00", active: true},
    { day: 4, shiftBegin: "8:00", shiftEnd: "17:00", breakBegin: "12:00", breakEnd: "13:00", active: true},
    { day: 5, shiftBegin: "", shiftEnd: "", breakBegin: "", breakEnd: "", active: false},
    { day: 6, shiftBegin: "", shiftEnd: "", breakBegin: "", breakEnd: "", active: false}
  ]
}


export class UserShiftWorkDay extends BaseModel<UserShiftWorkDay> {
  static DEFAULT_ATTRIBUTES = {}

  shiftBegin: string
  shiftEnd: string
  breakBegin: string
  breakEnd: string
  day: number
  active: boolean
}

export class UserShiftSettings extends BaseModel<UserShiftSettings> {
  static DEFAULT_ATTRIBUTES = {
    utcOffset: DEFAULT_USER_SHIFT_SETTINGS_PARAMS.utcOffset,
    workDays: DEFAULT_USER_SHIFT_SETTINGS_PARAMS.workDays.map(wd_settings => {
      return new UserShiftWorkDay(wd_settings)
    })
  }

  utcOffset: number
  workDays: UserShiftWorkDay[]
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/user-shift-settings.model.ts